export const IOS_APP = 'https://apps.apple.com/ru/app/%D1%82%D0%B2%D0%BE%D0%B9-%D1%80%D1%8B%D0%BD%D0%BE%D0%BA/id1551947692'
export const ANDROID_APP = 'https://play.google.com/store/apps/details?id=com.tvoyrynok'

export const OFFER_AGREEMENT_URL = 'https://storage.yandexcloud.net/tvoyrynok-storage/docs/customer/OFFER_AGREEMENT.pdf'
export const PRIVACY_POLICY_URL = 'https://storage.yandexcloud.net/tvoyrynok-storage/docs/customer/PRIVACY_POLICY.pdf'
